import { NAVIGATION_REQUEST, NAVIGATION_RESET } from "../../redux/action_constant";

/////////////////////////////////////////// ACTION TYPES ///////////////////////////////////////////
interface NavigationRequest {
    type: typeof NAVIGATION_REQUEST | typeof NAVIGATION_RESET;
    payload: string;
}

export const navigationRequest = (payload: string): NavigationRequest => ({ type: NAVIGATION_REQUEST, payload });

/////////////////////////////////////////// REDUCERS ///////////////////////////////////////////
interface NavigationState {
    NavigateTo: string;
}

const initialState: NavigationState = {
    NavigateTo: ''
};

const NavigationReducer = (state = initialState, action: NavigationRequest) => {
    switch (action.type) {
        case NAVIGATION_REQUEST:
            return {
                ...state,
                NavigateTo: action.payload,
            };
        case NAVIGATION_RESET:
            return {
                ...state,
                NavigateTo: '',
            };
        default:
            return {
                ...state,
            };
    }
};

export default NavigationReducer; 